import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import useWindowDimensions, { humanReadable } from '../../../../utils/useWindowDimensions';

const TimeSpentChart = ({ chartLabels, loadingChart }) => {
    let {width , height} = useWindowDimensions()
    const [chartData, setChartData] = useState({
        series: [
            { name: 'Guided', data: [] },
            { name: 'Unguided', data: [] },
        ],
        options: {
            chart: {
                type: 'bar',
                stacked: true,
                toolbar: {
                    show: true,
                },
                zoom: {
                    enabled: true,
                },
            },
            responsive: [
                {
                    breakpoint: 480,
                    options: {
                        legend: {
                            position: 'bottom',
                            offsetX: -10,
                            offsetY: 0,
                        },
                    },
                },
            ],
            plotOptions: {
                bar: {
                  horizontal: false,
                  dataLabels: {
                    enabled: false,
                  },
                },
              },
            xaxis: {
                categories: [],
            },
            legend: {
                position: 'right',
                offsetY: 40,
            },
            fill: {
                opacity: 1,
            },
        }
    });

    useEffect(() => {
        let chartBarName = [];
        let guidedValue = [];
        let unGuidedValue = [];
        if (chartLabels?.length > 0) {
            chartLabels.map((e, i) => {
                chartBarName.push(e.label);
                guidedValue.push(e.counts.guided.sum.inSeconds);
                unGuidedValue.push(e.counts.unguided.sum.inSeconds);
            });

          setChartData({
                series: [
                    {
                        name: 'Guided',
                        data: guidedValue
                    },
                    {
                        name: 'Unguided',
                        data: unGuidedValue
                    }
                ],
                dataLabels: {
                    enabled: false,
                    formatter: function (val) {
                        return val + "%";
                    },
                    offsetY: -20,
                    style: {
                        fontSize: '12px',
                        colors: ["#304758"]
                    }
                },
                options: {
                    chart: {
                        type: 'bar',
                        height: 350,
                        stacked: true,
                        toolbar: {
                            show: true,
                        },
                        zoom: {
                            enabled: true,
                        },
                    },
                    dataLabels: {
                      enabled: false
                  },
                    responsive: [
                        {
                            breakpoint: 480,
                            options: {
                                legend: {
                                    position: 'bottom',
                                    offsetX: -10,
                                    offsetY: 0,
                                },
                            },
                        },
                    ],
                    plotOptions: {
                        bar: {
                          horizontal: false,
                          dataLabels: {
                            enabled: false, // Set this to false to hide the numbers at the top and middle of the bars
                          },
                        },
                      },
                    xaxis: {
                        categories: chartBarName,
                    },
                    yaxis: {
                        labels: {
                            show: false,
                            formatter: (value , index) => {
                                return humanReadable(value);
                            }
                        }
                    },
                    legend: {
                        show: false, // Set this to false to hide the legend
                      },
                    fill: {
                        opacity: 1,
                    },
                    colors: ["#3e4095", "#333333"],
                }
            });

        }

    }, [chartLabels])

    return (
        <div id="chart">
            <ReactApexChart options={chartData.options} series={chartData.series} type="bar"  height={width > 1500 ? 250 : 198 } />
        </div>
    );
}

export default TimeSpentChart;
